import React, { useEffect, useState } from "react"
import { CMSPath, globalIV, globalSalt } from "../../../config/constant";
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { AesUtil } from "../../../JS/AesUtil";
import FooterNavigation from "../footerNaviagtion/footerNavigation"
import { currentWidget } from "../../../action/action";
import { setGoHome } from "../../action/homeAction";
import { scrollToTop } from "../../../JS/scrollToTop";


const TripPlanner = (props) => {
    const { widgetList } = props;
    const aesUtil = new AesUtil(128, 1000);


    const handleGoHome = () => {
        props.setGoHome(true);
    }

    // Helper to parse guest details from storage
    const fetchGuestDetails = () => {
        try {
            const guestDetailsFromLocalStorage = localStorage.getItem("Set_Current_Logged_In_Guest_Details");
            if (guestDetailsFromLocalStorage) {
                return JSON.parse(guestDetailsFromLocalStorage)[0];
            }

            const encryptedData = localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA");
            if (encryptedData) {
                return JSON.parse(aesUtil.decrypt(globalSalt, globalIV, "1234567891234567", encryptedData));
            }
        } catch (error) {
            console.error("Error fetching guest details:", error);
        }
        return {};
    };

    // Attach the Trip Planner
    const attachTripPlanner = () => {
        const guestDetails = fetchGuestDetails();
        const targetUrl = props.currentWidgetObj && props.currentWidgetObj.targetUrl;
        let resolvedUrl = null;

        if (targetUrl) {
            resolvedUrl = targetUrl.startsWith("http")
                ? targetUrl.replace("#RESERVATION_ID", guestDetails.reservationNumber || "")
                : CMSPath + targetUrl.replace("#RESERVATION_ID", guestDetails.reservationNumber || "");
        }

        let widgetConfig = {};
        if (resolvedUrl) {
            let urlParams = new URLSearchParams(resolvedUrl.split("?")[1]); // Parse URL parameters

            widgetConfig = Object.fromEntries(urlParams.entries());
        }

        setTimeout(() => {
            window.InnspireTP.TripPlanner.render({selector:"tripPlanner", url: resolvedUrl, handleGoHome});
        }, 0);
    };

    useEffect(() => {
        scrollToTop();
        attachTripPlanner();

        return () => {
            handleGoHome();
        }
    }, []);

    return (
        <div>
            <div id="tripPlanner"></div>;
            <FooterNavigation />
        </div>
    )
};


const mapStateToProps = state => {
    return {
        currentWidgetObj: state.store.sideNavBar.currentWidget,
    }
}

export default connect(
    mapStateToProps,
    {
        currentWidget,
        setGoHome
    }
)(TripPlanner);
